export const cellProps = {
    icon: String,
    size: String,
    center: {
        type: Boolean,
        default: true,
    },
    isLink: {
        type: Boolean,
        default: true,
    },
    required: Boolean,
    iconPrefix: String,
    titleStyle: null,
    titleClass: null,
    valueClass: null,
    labelClass: null,
    title: [Number, String],
    value: [Number, String],
    label: [Number, String],
    arrowDirection: String,
    border: {
        type: Boolean,
        default: true,
    },
    clickable: {
        type: Boolean,
        default: null,
    },
    href: String,
    target: { type: String, default: '_self' },
    to: [String, Object],
    replace: { type: Boolean, default: false },
    append: { type: Boolean, default: false },
    decoration: { type: Boolean, default: true },
    download: { type: Boolean, default: false },
    destination: String,
    vusionCut: Boolean,
    vusionMove: Boolean,
    vusionNodePath: String,
    vusionNodeTag: String,
    vusionTemplateInputNodePath: String,
    vusionTemplateTitleNodePath: String,
};
